import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, ToastController, AlertController, App, LoadingController, Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';
import { ServiceSidemenuProvider } from '../providers/service-sidemenu/service-sidemenu';

//page
import { A01LoginPage } from '../pages/a01-login/a01-login';
import { B01DashboardPage } from '../pages/b01-dashboard/b01-dashboard';
import { B02UserManagementPage } from '../pages/b02-user-management/b02-user-management';
import { B02iCustomerManagementPage } from '../pages/b02i-customer-management/b02i-customer-management';
import { B03CardManagementPage } from '../pages/b03-card-management/b03-card-management';
import { B04InventoryManagementPage } from '../pages/b04-inventory-management/b04-inventory-management';
import { B05PurchaseOrderPage } from '../pages/b05-purchase-order/b05-purchase-order';
import { B06SupplierPage } from '../pages/b06-supplier/b06-supplier';
import { B07InvoicePage } from '../pages/b07-invoice/b07-invoice';
import { B08ReportManagementPage } from '../pages/b08-report-management/b08-report-management';
import { B09SettingPage } from '../pages/b09-setting/b09-setting';
import { B10LogoutPage } from '../pages/b10-logout/b10-logout';
import { B11PaymentTypeManagementPage } from '../pages/b11-payment-type-management/b11-payment-type-management';


@Component({
  templateUrl: 'app.html'
})
export class MyApp {

  @ViewChild(Nav) nav: Nav;

  rootPage: any = A01LoginPage;
//  pages: Array<{title: string, component: any, class:any, icon:string}>;
  pages=[];
  accessPage: any = {title:'', component: '', class:'', icon:''};
  loading: any;
  userAccessId: any = null;
  accessResult: any;
  userGrpId: any = null;

  constructor(public platform: Platform, public statusBar: StatusBar, 
              public splashScreen: SplashScreen, public sidemenu:ServiceSidemenuProvider,
              public app: App, private toastCtrl: ToastController, 
              public alertCtrl : AlertController, public loadingCtrl: LoadingController,
              public events: Events) {

    this.initializeApp();

    if(sessionStorage.getItem("useraccessid") != null)
    {
      let useraccess = sessionStorage.getItem("useraccessid");
      let i=0;
      let user = useraccess.split(',');

      this.userAccessId = user;

      this.showmenu();

      events.subscribe('user:created', (username, useraccess, time, usergrpid) => {
        // user and time are the same arguments passed in `events.publish(user, time)`
        this.userAccessId = useraccess;

        this.showmenu();
        this.userGrpId = usergrpid;
        console.log(this.userGrpId);
        if ((this.userGrpId == "6") || (this.userGrpId == "7") || (this.userGrpId == "8"))  //corporate go card
          this.nav.setRoot(B03CardManagementPage);
        else                                                                                //system admin & branch go dashboard
          this.nav.setRoot(B01DashboardPage);
  
      });
    }
    else
    {
      // events in case of different user authority
      events.subscribe('user:created', (username, useraccess, time, usergrpid) => {
        // user and time are the same arguments passed in `events.publish(user, time)`
        this.userAccessId = useraccess;

        this.showmenu();
        this.userGrpId = usergrpid;
        console.log(this.userGrpId);
        if ((this.userGrpId == "6") || (this.userGrpId == "7") || (this.userGrpId == "8"))  //corporate go card
          this.nav.setRoot(B03CardManagementPage);
        else                                                                                //system admin & branch go dashboard
          this.nav.setRoot(B01DashboardPage);
    
  /*       this.pages = [
          { title: 'Dashboard', component: B01DashboardPage, class:'sidemenu-active', icon:'home' },
          { title: 'User', component: B02UserManagementPage, class:'sidemenu-non-active', icon:'person' },
          { title: 'Customer', component: B02iCustomerManagementPage, class:'sidemenu-non-active', icon:'contacts' },
          { title: 'Card', component: B03CardManagementPage, class:'sidemenu-non-active', icon:'card' },
          { title: 'Inventory', component: B04InventoryManagementPage, class:'sidemenu-non-active', icon:'cube' },
          { title: 'Purchase', component: B05PurchaseOrderPage, class:'sidemenu-non-active', icon:'cart' },
          { title: 'Supplier', component: B06SupplierPage, class:'sidemenu-non-active', icon:'people' },
          { title: 'Invoice', component: B07InvoicePage, class:'sidemenu-non-active', icon:'calculator' },
          { title: 'Report', component: B08ReportManagementPage, class:'sidemenu-non-active', icon:'clipboard' },
          { title: 'Setting', component: B09SettingPage, class:'sidemenu-non-active', icon:'construct' },
          { title: 'Logout', component: B10LogoutPage, class:'sidemenu-non-active', icon:'log-out' },
        ]; */
      });
    }

  }

  showmenu()
  {
    if((this.userAccessId.some(x => x === "1")) == true)            //check access id and filter side menu page
        {
          this.accessPage = { title: 'Dashboard', component: B01DashboardPage, class:'sidemenu-active', icon:'home' };
          this.pages.push(this.accessPage);
        } 
        if((this.userAccessId.some(x => x === "2")) == true)
        {
          this.accessPage = { title: 'User', component: B02UserManagementPage, class:'sidemenu-non-active', icon:'person' };
          this.pages.push(this.accessPage);
        } 
        if((this.userAccessId.some(x => x === "3")) == true)
        {
          this.accessPage = { title: 'Customer', component: B02iCustomerManagementPage, class:'sidemenu-non-active', icon:'contacts' };
          this.pages.push(this.accessPage);
        } 
        if((this.userAccessId.some(x => x === "4")) == true)
        {
          this.accessPage = { title: 'Card', component: B03CardManagementPage, class:'sidemenu-non-active', icon:'card' };
          this.pages.push(this.accessPage);
        } 
        if((this.userAccessId.some(x => x === "5")) == true)
        {
          this.accessPage = { title: 'Inventory', component: B04InventoryManagementPage, class:'sidemenu-non-active', icon:'cube' };
          this.pages.push(this.accessPage);
        }
        if((this.userAccessId.some(x => x === "6")) == true)
        {
          this.accessPage = { title: 'Purchase', component: B05PurchaseOrderPage, class:'sidemenu-non-active', icon:'cart' };
          this.pages.push(this.accessPage);
        } 
        if((this.userAccessId.some(x => x === "7")) == true)
        {
          this.accessPage = { title: 'Supplier', component: B06SupplierPage, class:'sidemenu-non-active', icon:'people' };
          this.pages.push(this.accessPage);
        }
        if((this.userAccessId.some(x => x === "8")) == true)
        {
          this.accessPage = { title: 'Invoice', component: B07InvoicePage, class:'sidemenu-non-active', icon:'calculator' };
          this.pages.push(this.accessPage);
        }
        if((this.userAccessId.some(x => x === "16")) == true)
        {
          this.accessPage = { title: 'Payment', component: B11PaymentTypeManagementPage, class:'sidemenu-non-active', icon:'cash' };
          this.pages.push(this.accessPage);
        }
        if((this.userAccessId.some(x => x === "9")) == true)
        {
          this.accessPage = { title: 'Report', component: B08ReportManagementPage, class:'sidemenu-non-active', icon:'clipboard' };
          this.pages.push(this.accessPage);
        } 
        if((this.userAccessId.some(x => x === "10")) == true)
        {
          this.accessPage = { title: 'Setting', component: B09SettingPage, class:'sidemenu-non-active', icon:'construct' };
          this.pages.push(this.accessPage);
        }

        this.accessPage = { title: 'Logout', component: B10LogoutPage, class:'sidemenu-non-active', icon:'log-out' };
        this.pages.push(this.accessPage);
  }
  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario

    if (page.title == 'Logout'){                        //pop up window for logout
      let confirm = this.alertCtrl.create({
        title: 'Confirmation',
        message: 'Are you sure you want to logout?',
        buttons: [
          {
            text: 'No',
            handler: () => {
            console.log('Disagree clicked');
            }
          }, 
          {
            text: 'Yes',
            handler: () => {
            console.log('Agree clicked');
              
            this.showLoader();
  
            sessionStorage.clear();                       //clear temporary user data
            this.pages=[];                                //clear side menu page
            this.nav.setRoot(A01LoginPage);
  
            setTimeout(()=>{
              this.loading.dismiss();  
            },500);
          
  
            }
          }
        ]
      });
      confirm.present();
      
    }
    else {
      this.nav.setRoot(page.component);
      page.class='sidemenu-active';

      for (let p of this.pages) {
      
        if(p.title==page.title)
        {
          p.class='sidemenu-active';
        }
        else
        {
          p.class='sidemenu-non-active';
        }
      }
    }
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Logout...',
        duration: 5000
    });

    this.loading.present();
  }

}




// WEBPACK FOOTER //
// ./src/app/app.component.ts